import './App.css';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { Tooltip } from "@mui/material";
import { IoArrowDownOutline, IoArrowUpOutline, IoLogOut } from "react-icons/io5";
import { IoBalloonOutline } from "react-icons/io5";
import { AiOutlineDelete } from 'react-icons/ai';
import { CiExport } from 'react-icons/ci';
import { TbPolygon } from 'react-icons/tb';
import { FaTasks } from "react-icons/fa";
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import LoadingIcons from 'react-loading-icons';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoIosSave } from "react-icons/io";
import { useHistory } from 'react-router-dom';
import { FaStepBackward, FaStepForward, FaFastForward, FaFastBackward } from 'react-icons/fa';
import { RxGroup } from "react-icons/rx";
import pointInPolygon from "point-in-polygon";
import { IoReorderFour } from "react-icons/io5";
import { red } from '@mui/material/colors';
import Checkbox from '@mui/material/Checkbox';
import { MdDeleteOutline } from "react-icons/md";
import Modal from './comps/modal';
import Countdown from './comps/Countdown';
import { FaPlus } from "react-icons/fa";
import { MdLiveHelp } from "react-icons/md";
import { PiNoteBlankLight } from "react-icons/pi";
import { RiNumber1, RiNumber2, RiNumber3, RiNumber4, RiNumber5, RiNumber6, RiNumber7, RiNumber8, RiNumber9 } from "react-icons/ri";
import { RxDividerVertical } from "react-icons/rx";
import { IoIosUndo } from "react-icons/io";
import { useLocation } from 'react-router-dom';

const Core = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [zoomLevel, setZoomLevel] = useState(1);
  const svgRef = useRef(null);
  const [panning, setPanning] = useState({ disabled: false });
  const [zoomBoolean, setZoomBoolean] = useState(false);
  const [stepValue, setStepValue] = useState(0.7);
  const [fileList, setFileList] = useState([]);
  const [jsonFile, setJsonFile] = useState([]);
  const [jsonData, setJsonData] = useState([]);
  const [jsonData1, setJsonData1] = useState([]);
  const [selectedBbox, setSelectedBbox] = useState(null);
  const [imgSource1, setImgSource1] = useState("");
  const addDataBtn = useRef(null);
  const exportDataBtn = useRef(null);
  const [imgIndex, setImgIndex] = useState(0);
  const [axisLine, setAxisLine] = useState({ x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0, x4: 0, y4: 0 });
  const [selectedEllip, setSelectedEllip] = useState(null);
  const [selKey, setSelKey] = useState(null);
  const [svgDimi, setSvgDimi] = useState({ wid: 0, hei: 0 });
  const [open, setOpen] = useState(false);
  const textAreaRef = useRef(null);
  const [curPos, setCurPos] = useState();
  const [draw, setDraw] = useState(false);
  const [group, setGroup] = useState(false);
  const [edit, setEdit] = useState(false);
  const [del, setDel] = useState(false);
  const [dragging, setDragging] = useState(null);
  const [handleDrag, setHandleDrag] = useState(null);
  const [mouseOffset, setMouseOffset] = useState({ x: 0, y: 0 });
  const icons = ['⌀', '±', '⊥', '//', '↧', '▱', '⌴', '⌓', '⌵', '+', '-', '◯', '∩', '∠', '⌖', '◎', '⌯', '⌰', '↗', '°', '≥', '≤', 'µ', '✓', '℄', '⌭', '↔︎'];
  const labels = ['Diameter', 'Plus or Minus', 'Perpendicularity', 'Parallelism', 'Depth', 'Flatness', 'Counterbore',
    'Profile of a Surface', 'Countersink', 'Plus', 'Minus', 'Circularity', 'Profile of a Line', 'Angularity', 'True Position ',
    'Concentricity', 'Symmetry', 'Total Runout', 'Runout', 'Degree', 'Greater Than or Equal To', 'Less Than or Equal To', 'Micro', 'Surface Finish', 'Centerline', 'cylindricity', 'Range'];
  const icons1 = ['±', '°'];
  const [boxes, setBoxes] = useState([]);
  const [startPoint, setStartPoint] = useState({ x: 0, y: 0 });
  const [isDrawing, setIsDrawing] = useState(false);
  const [ppe, setPpe] = useState(null);
  const [ppeb, setPpeb] = useState(false);
  const [imgOrgDim, setImgOrgDim] = useState({ imgWidth: 0, imgHeight: 0 });
  const [imgOrgDimArr, setImgOrgDimArr] = useState([]);
  const nxtImgBtn = useRef(null);
  const prevImgBtn = useRef(null);
  const [gloTol, setGloTol] = useState({});
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [grouping, setGrouping] = useState([]);
  const [wholeGroup, setWholeGroup] = useState([]);
  const [selectionBox, setSelectionBox] = useState(null);
  const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [lastActivity, setLastActivity] = useState(null);
  const [pausedSeconds, setPausedSeconds] = useState(0);
  const numberIcons = {
    1: <RiNumber1 />,
    2: <RiNumber2 />,
    3: <RiNumber3 />,
    4: <RiNumber4 />,
    5: <RiNumber5 />,
    6: <RiNumber6 />,
    7: <RiNumber7 />,
    8: <RiNumber8 />,
    9: <RiNumber9 />,
  };
  const [masterData, setMasterData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [poly, setPoly] = useState([]);
  const [polyHistory, setPolyHistory] = useState([]);
  const [angData, setAngData] = useState([]);
  const [data, setData] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [isRedirecting, setRedirecting] = useState(false);
  const [deletedRows, setDeletedRows] = useState([]);
  const [isModalOpens, setIsModalOpens] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);
  const location = useLocation();
  const taskId = location.state?.taskId;

  const handleRowClick = (e, index) => {
    e.preventDefault();
    setSelectedRow(index);
    setContextMenu({
      mouseX: e.clientX,
      mouseY: e.clientY,
    });
  };

  const handleDeleteRow = () => {
    if (selectedRow !== null) {
      const clone = [...masterData];
      if (clone[imgIndex]?.length > selectedRow) {
        clone[imgIndex].splice(selectedRow, 1);
        let start = 1;
        clone.forEach((sub) => {
          sub.forEach((obj) => {
            // if (obj["ID"] > selectedBbox) {
            obj["ID"] = start;
            start++
            // }
          })
        })
        setMasterData(clone);
      }
    }
    handleCloseMenu();
  };

  const handleCloseMenu = () => {
    setContextMenu(null);
    setSelectedRow(null);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCountdownComplete = () => {
    history.push('/task');
    toast.success('Redirected successfully!');
  };

  const handleKeyChange = (oldKey, newKey) => {
    if (newKey.length > 1) {
      const obj = { ...gloTol };
      let sData = obj[oldKey];
      delete obj[oldKey];
      obj[newKey] = sData;
      setGloTol(obj);
    }
  };

  const handleValueChange = (key, newValue) => {
    const originalValue = gloTol[key];
    const Plus = /[±+]/.test(originalValue);
    if (Plus) {
      if (/[±+]/.test(newValue)) {
        setGloTol(prevData => ({
          ...prevData,
          [key]: newValue,
        }));
      }
    } else {
      setGloTol(prevData => ({
        ...prevData,
        [key]: newValue,
      }));
    }
  };
  
  const handleDelete = (key) => {
    const index = Object.keys(gloTol).indexOf(key);
    setDeletedRows((prevRows) => [...prevRows, { key, value: gloTol[key], index }]);
    setGloTol((prevData) => {
      const newData = { ...prevData };
      delete newData[key];
      return newData;
    });
  };

  const handlePlus = () => {
    setIsModalOpens(true);
  };

  const handleReAdd = (row) => {
    setGloTol((prevData) => {
      const newData = { ...prevData };
      const entries = Object.entries(newData);
      entries.splice(row.index, 0, [row.key, row.value]);
      return Object.fromEntries(entries);
    });
    setDeletedRows((prevRows) => prevRows.filter((r) => r.key !== row.key));
    setIsModalOpens(false);
  };

  const handleClickOutside = (event) => {
    if (event.target.id === 'orange') {
      setIsModalOpens(false);
    }
  };

  const toggleModal = (e) => {
    setIsModalOpen1(!isModalOpen);
  };

  const handleClickOutside1 = (event) => {
    if (event.target.id === 'apple') {
      setIsModalOpen1(false);
    }
  };

  const transformWrapperRef = useRef(null);
  const handleZoom = (id) => {
    console.log(` ${id}`);
    const textElements = document.querySelectorAll('#svg-container-id text');
    const element = Array.from(textElements).find(el => el.textContent.trim() === id.toString());
    if (!element) {
      console.log(`Element with ID ${id} not found`);
      return;
    }

    const bbox = element.getBoundingClientRect();
    const svgContainer = document.getElementById('svg-container-id').getBoundingClientRect();
    textElements.forEach(el => el.style.fill = 'red');
    element.style.fill = 'blue';

    const elementCenterX = bbox.left + bbox.width / 2 / zoomLevel;
    const elementCenterY = bbox.top + bbox.height / 2 / zoomLevel;
    const svgCenterX = svgContainer.left + svgContainer.width / 2 / zoomLevel;
    const svgCenterY = svgContainer.top + svgContainer.height / 2 / zoomLevel;
    const translateX = svgCenterX - elementCenterX;
    const translateY = svgCenterY - elementCenterY;

    const scale = 3;
    if (transformWrapperRef.current) {
      transformWrapperRef.current.setTransform(translateX, translateY, scale, 800, "easeOutQuad");
    }
  };

  const handleTransform = (props) => {
    setZoomLevel(props.state.scale);
  };

  const handleZoomOutStep = (e) => {
    e.preventDefault();
    e.deltaY > 0 ? setStepValue(1.8) : setStepValue(0.7);
  };

  const saveJsonData = async () => {
    let obj = {
      // "id": props.location.state.split(":")?.[0],
      "id": props.location.state.taskId,
      "global_tolerance": [{ ...gloTol }],
      // "grouping_ids": processGroupingDataExport(grouping),
      "data": fullData,
      "pause": "True",
      "blank": "False"
    };
    obj.data = processExportData(masterData);
    console.log("sending", obj)
    try {
      const response = await toast.promise(axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/task/`, obj, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
        }
      }),
        {
          pending: 'Saving Data..!',
          success: 'Data Saved...!'
        }
      );
    }
    catch (error) {
      console.log("Export Error", error);
      toast.error("Failed to export data!");
    }
  };

  const blankJsonData = async () => {
    let obj = {
      // "id": props.location.state.split(":")?.[0],
      "id": props.location.state.taskId,
      "global_tolerance": [{ ...gloTol }],
      // "grouping_ids": processGroupingDataExport(grouping),
      "data": fullData,
      "pause": "True",
      "blank": "True"
    };
    obj.data = processExportData(masterData);

    try {
      const response = await toast.promise(axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/task/`, obj, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
        }
      }),
        {
          pending: 'Saving Data..!',
          success: 'Data Saved...!'
        }
      );
    }
    catch (error) {
      console.log("Export Error", error);
      toast.error("Failed to export data!");
    }
  };

  const submitJsonData = async () => {
    console.log(JSON.stringify({ message: "submitJsonData function called" }));
    let obj = {
      "id": props.location.state.taskId,
      "global_tolerance": [{ ...gloTol }],
      // "grouping_ids": processGroupingDataExport(grouping),
      "data": fullData,
      "pause": "False",
      "blank": "False"
    };
    console.log(JSON.stringify({ message: "Initial obj created", obj }));
    obj.data = processExportData(masterData);
    console.log(JSON.stringify({ message: "Processed data", data: obj.data }));
    try {
      console.log(JSON.stringify({ message: "Sending POST request", url: `${process.env.REACT_APP_BE_MAIN_URL}/ocr/task/` }));
      const response = await toast.promise(
        axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/task/`, obj, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
          }
        }),
        {
          pending: 'Saving Data..!',
          success: 'Data Saved...!'
        }
      );
      console.log(JSON.stringify({ message: "Response from server", response }));
      if (response) {
        console.log(JSON.stringify({ message: "Data saved successfully, closing modal and redirecting" }));
        handleCloseModal();
        setRedirecting(true);
      }
    } catch (error) {
      console.log(JSON.stringify({ message: "Export Error", error: error.toString() }));
      toast.error("Failed to export data!");
    }
  };

  const handleFolderSelect = (event) => {
    // event.preventDefault();
    // event.stopPropagation();
    const directoryInput = document.createElement("input");
    directoryInput.setAttribute("type", "file");
    directoryInput.setAttribute("webkitdirectory", true);
    directoryInput.setAttribute("directory", true);
    directoryInput.setAttribute("multiple", true);
    directoryInput.click();
    directoryInput.addEventListener("change", handleFileSelect, false);
  };

  const handleFileSelect = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const fileList = event.target.files;
    const pngFiles = Array.from(fileList).filter((file) =>
      file.type.startsWith("image/")
    );
    if (pngFiles.length === 0) {
      return;
    }
    else if (pngFiles.length > 0) {
      const jsonFiles = Array.from(fileList).filter((file) => file.type.startsWith("application/json"));
      setFileList(pngFiles);
      setJsonFile(jsonFiles);
    }
  };

  const handlePolyPointEdit = (e, ind) => {
    setPolyHistory((prevHistory) => [...prevHistory, [...poly]]);
    setPpeb(true);
    setPpe(ind);
  };

  const handleUndo = () => {
    if (polyHistory.length > 0) {
      const lastState = polyHistory[polyHistory.length - 1];
      setPoly(lastState);
      setPolyHistory((prevHistory) => prevHistory.slice(0, -1));
      console.log("Undo performed. Updated polyHistory:", polyHistory);
    }
  };
  const handleDeletePoint = (index) => {
    setPolyHistory((prevHistory) => [...prevHistory, [...poly]]);
    setPoly((prevPoly) => prevPoly.filter((_, i) => i !== index));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "z") {
        event.preventDefault();
        handleUndo();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [polyHistory]);

  const handleKeyDown1 = (e, index) => {
    if (e.ctrlKey && e.key === 'm') {
      e.preventDefault();
      console.log('ctrl + m detected');
      const clone = [...masterData];
      const updatedText = clone[imgIndex][index].text.split(' ').join('');
      clone[imgIndex][index] = { ...clone[imgIndex][index], text: updatedText };
      setMasterData(clone);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown1);
    return () => {
      document.addEventListener('keydown', handleKeyDown1)
    };
  }, []);

  const handleRectMouseDown = (e, ind, handle) => {
    if (!draw) {
      setSelectedBbox(ind)
      setSelectedEllip(false);

    };
    if (del) {
      const clone = [...masterData];
      clone[imgIndex].splice(ind, 1)
      setMasterData(clone);
      return;
    }
    if (!draw) {
      const cloned = [...masterData];
      setDragging(ind);
      setHandleDrag(handle);
      const svgElement = svgRef.current;
      const { left, top } = svgElement.getBoundingClientRect();
      const mouseX = (e.clientX - left) / zoomLevel;
      const mouseY = (e.clientY - top) / zoomLevel;
      // let dataClone = jsonData1;
      setMouseOffset({
        x: mouseX - cloned[imgIndex][ind]["bbox"]?.[0],
        y: mouseY - cloned[imgIndex][ind]["bbox"]?.[1]
      });
    }
  };

  const handleGrouping = (e) => {
    if (group && e.button === 0) {
      const svgElement = svgRef.current;
      const { left, top } = svgElement.getBoundingClientRect();
      const arr = [...poly];
      arr.push({
        x: (e.clientX - left) / zoomLevel,
        y: (e.clientY - top) / zoomLevel,
      });
      setPoly(arr);
      setPolyHistory((prevHistory) => [...prevHistory, [...poly]]);
    }
  };

  const handleAddballooning = (e) => {
    if (draw && e.button === 0) {
      setIsDrawing(true);
      const svgElement = svgRef.current;
      const { left, top } = svgElement.getBoundingClientRect();
      setStartPoint({
        x: (e.clientX - left) / zoomLevel,
        y: (e.clientY - top) / zoomLevel,
        width: 0,
        height: 0
      });
    }
  };

  const handlePositionChange = (e) => {
    if (draw && isDrawing) {
      const svgElement = svgRef.current;
      const { left, top } = svgElement.getBoundingClientRect();
      const newBox = {
        ...startPoint,
        x: Math.min(startPoint.x, (e.clientX - left) / zoomLevel),
        y: Math.min(startPoint.y, (e.clientY - top) / zoomLevel),
        width: Math.abs(((e.clientX - left) / zoomLevel) - startPoint.x),
        height: Math.abs(((e.clientY - top) / zoomLevel) - startPoint.y)
      };
      setBoxes([newBox]);
      return;
    }

    if (!draw && ppeb && ppe !== null) {
      const svgElement = svgRef.current;
      const { left, top } = svgElement.getBoundingClientRect();
      const latP = {
        x: (e.clientX - left) / zoomLevel,
        y: (e.clientY - top) / zoomLevel
      };
      const arr = [...poly];
      arr.splice(ppe, 1, latP);
      setPoly(arr);
      return;
    }

    if (!draw && selectedEllip !== null) {
      const svgElement = svgRef.current;
      const svgRect = svgElement.getBoundingClientRect();
      const mouseX = (e.clientX - svgRect.left) / zoomLevel;
      const mouseY = (e.clientY - svgRect.top) / zoomLevel;

      // Calculating new center of the ellipse
      const newCenterX = mouseX + (masterData[imgIndex][selectedEllip]?.ellips_box[2] - masterData[imgIndex][selectedEllip]?.ellips_box[0]) / 2;
      const newCenterY = mouseY + (masterData[imgIndex][selectedEllip]?.ellips_box[3] - masterData[imgIndex][selectedEllip]?.ellips_box[1]) / 2;

      // Updating ellipse center
      const newData = {
        ...masterData[imgIndex][selectedEllip],
        ellips_box: [
          newCenterX - (masterData[imgIndex][selectedEllip].ellips_box[2] - masterData[imgIndex][selectedEllip].ellips_box[0]) / 2,
          newCenterY - (masterData[imgIndex][selectedEllip].ellips_box[3] - masterData[imgIndex][selectedEllip].ellips_box[1]) / 2,
          newCenterX + (masterData[imgIndex][selectedEllip].ellips_box[2] - masterData[imgIndex][selectedEllip].ellips_box[0]) / 2,
          newCenterY + (masterData[imgIndex][selectedEllip].ellips_box[3] - masterData[imgIndex][selectedEllip].ellips_box[1]) / 2
        ]
      };
      const clone = [...masterData];
      clone[imgIndex][selectedEllip] = newData;
      setMasterData(clone);
    }

    if (!draw && dragging !== null) {
      const svgElement = svgRef.current;
      const { left, top } = svgElement.getBoundingClientRect();
      let dataClone = [...masterData];
      if (handleDrag === "top-left") {
        dataClone[imgIndex][dragging].bbox[0] = Math.abs((e.clientX - left) / zoomLevel);
        dataClone[imgIndex][dragging].bbox[1] = Math.abs((e.clientY - top) / zoomLevel);
        dataClone[imgIndex][dragging].bbox[2] = Math.abs(dataClone[imgIndex][dragging].bbox[0] + (dataClone[imgIndex][dragging].bbox[0] + (dataClone[imgIndex][dragging].bbox[2] - dataClone[imgIndex][dragging].bbox[0]) - ((e.clientX - left) / zoomLevel)));
        dataClone[imgIndex][dragging].bbox[3] = Math.abs(dataClone[imgIndex][dragging].bbox[1] + (dataClone[imgIndex][dragging].bbox[1] + (dataClone[imgIndex][dragging].bbox[3] - dataClone[imgIndex][dragging].bbox[1]) - ((e.clientY - top) / zoomLevel)));
      } else if (handleDrag === "top-right") {
        dataClone[imgIndex][dragging].bbox[1] = Math.abs((e.clientY - top) / zoomLevel);
        dataClone[imgIndex][dragging].bbox[2] = Math.abs(dataClone[imgIndex][dragging].bbox[0] + (((e.clientX - left) / zoomLevel) - dataClone[imgIndex][dragging].bbox[0]));
        dataClone[imgIndex][dragging].bbox[3] = Math.abs(dataClone[imgIndex][dragging].bbox[1] + (dataClone[imgIndex][dragging].bbox[1] + (dataClone[imgIndex][dragging].bbox[3] - dataClone[imgIndex][dragging].bbox[1]) - ((e.clientY - top) / zoomLevel)));
      } else if (handleDrag === "bottom-left") {
        dataClone[imgIndex][dragging].bbox[0] = Math.abs((e.clientX - left) / zoomLevel);
        dataClone[imgIndex][dragging].bbox[2] = Math.abs(dataClone[imgIndex][dragging].bbox[0] + (dataClone[imgIndex][dragging].bbox[0] + (dataClone[imgIndex][dragging].bbox[2] - dataClone[imgIndex][dragging].bbox[0]) - ((e.clientX - left) / zoomLevel)));
        dataClone[imgIndex][dragging].bbox[3] = Math.abs(dataClone[imgIndex][dragging].bbox[1] + (((e.clientY - top) / zoomLevel) - dataClone[imgIndex][dragging].bbox[1]));
      } else if (handleDrag === "bottom-right") {
        dataClone[imgIndex][dragging].bbox[2] = Math.abs(dataClone[imgIndex][dragging].bbox[0] + (((e.clientX - left) / zoomLevel) - dataClone[imgIndex][dragging].bbox[0]));
        dataClone[imgIndex][dragging].bbox[3] = Math.abs(dataClone[imgIndex][dragging].bbox[1] + (((e.clientY - top) / zoomLevel) - dataClone[imgIndex][dragging].bbox[1]));
      } else if (handleDrag === "bb-drag") {
        const newX = (e.clientX - left) / zoomLevel - mouseOffset.x;
        const newY = (e.clientY - top) / zoomLevel - mouseOffset.y;
        const cWid = dataClone[imgIndex][dragging].bbox[2] - dataClone[imgIndex][dragging].bbox[0];
        const cHei = dataClone[imgIndex][dragging].bbox[3] - dataClone[imgIndex][dragging].bbox[1];
        dataClone[imgIndex][dragging].bbox[0] = Math.abs(newX);
        dataClone[imgIndex][dragging].bbox[1] = Math.abs(newY);
        dataClone[imgIndex][dragging].bbox[2] = newX + cWid;
        dataClone[imgIndex][dragging].bbox[3] = newY + cHei;
      }
      setMasterData(dataClone);
    }
  };

  const getCallOutId = (ia) => {
    if (ia.length === 0) return 1;
    const arr = [...ia];
    let min = Math.min(...arr);
    let max = Math.max(...arr);
    for (let i = 1; i <= max; i++) {
      if (!(arr.includes(i))) {
        return i;
      }
    }
    return Math.max(...arr) + 1;
  };

  const isIntersecting = (rect, bbox) => {
    const { x1, y1, x2, y2 } = rect;
    const [bx1, by1, bx2, by2] = bbox;
    return !(x2 < bx1 || x1 > bx2 || y2 < by1 || y1 > by2);
  };

  const generateShortUUID = () => {
    return String(Math.floor(1000 + Math.random() * 9000));
  };

  const handleRelease = async (event) => {
    setSelectionBox(null);
    setHandleDrag(null);
    setDragging(null);
    setSelectedEllip(null);
    if (draw) {
      console.log("Original Image Dimensions:", imgOrgDim);
      const clone = [...masterData];
      const idArr = [];
      clone[imgIndex].forEach((sub) => idArr.push(sub["ID"]));
      const obj = {
        "ID": getCallOutId(idArr),
        "PageNumber": 0,
        "text": "",
        "text_id": generateShortUUID(4),
        "description": "",
        "bbox": [
          boxes[0].x,
          boxes[0].y,
          boxes[0].x + boxes[0].width,
          boxes[0].y + boxes[0].height
        ],
        // "arrow_position": null,  
        "ellips_box": [
          (boxes[0].x + (boxes[0].width / 2)) - returnCanvasVal(19.64),
          (boxes[0].y - 50 + (boxes[0].height / 2)) - returnCanvasVal(16.78),
          (boxes[0].x + (boxes[0].width / 2)) + returnCanvasVal(19.64),
          (boxes[0].y - 50 + (boxes[0].height / 2)) + returnCanvasVal(16.78),
        ],
        "ctq": false
        // "text_position": [
        //   null,
        //   null
        // ],
      };

      function scaleCoordinates(coordinate) {
        const { imgWidth, imgHeight } = imgOrgDimArr[imgIndex];
        let arr = [
          (imgWidth * coordinate[0]) / svgDimi.wid,
          (imgHeight * coordinate[1]) / svgDimi.hei,
          (imgWidth * coordinate[2]) / svgDimi.wid,
          (imgHeight * coordinate[3]) / svgDimi.hei
        ];
        return arr
      }
      console.log({
        "image_url": imgSource1,
        "crop_coords": scaleCoordinates(obj?.["bbox"])
      }, process.env.REACT_APP_BE_MAIN_URL1)
      axios.post(`${process.env.REACT_APP_BE_MAIN_URL1}/bbox_coordinates/`, {
        "image_url": imgSource1,
        "crop_box": scaleCoordinates(obj?.["bbox"])
      }, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
        }
      })

        .then((response) => {
          console.log("RESPONSE", response);
          const dc = [...masterData];
          obj.text = typeof response.data["extracted_text"] === "string"
            ? response.data["extracted_text"]
            : response.data?.result || '';
          obj.text_id = response.data?.text_id || generateShortUUID(4);
          dc[imgIndex].push(obj);
          let start = 1;
          dc.forEach((sub) => {
            sub.forEach((obj) => {
              // if (obj["ID"] > selectedBbox) {
              obj["ID"] = start;
              start++
              // }
            })
          })
          dc.forEach((iw) => {
            iw.sort((a, b) => a["ID"] - b["ID"]);
          });
          setMasterData(dc);
          setBoxes([]);
          setDraw(false);
        })

        .catch(err => {
          console.log(err)
          const dc = [...masterData];
          obj.text_id = generateShortUUID(4);
          dc[imgIndex].push(obj);
          let start = 1;
          dc.forEach((sub) => {
            sub.forEach((obj) => {
              // if (obj["ID"] > selectedBbox) {
              obj["ID"] = start;
              start++
              // }
            })
          })
          dc.forEach((iw, index) => {
            iw.sort((a, b) => a["ID"] - b["ID"]);
          });
          setMasterData(dc);
          setBoxes([]);
          setDraw(false);
        })
      // const response = await toast.promise(axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/box/`, {
      //   "image_url": imgSource1,
      //   "crop_coords": scaleCoordinates(obj?.["bbox"])
      // }, {
      //   headers: {
      //     Accept: 'application/json',
      //     Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
      //   }
      // }))
      // console.log("Box OCR", response)
      // try {
      //   if (response) {
      //     console.log("Box OCR", response)
      //   }
      // } catch (err) {
      //   console.error("Box OCR", err)
      // }

      // const dc = [...masterData];
      // dc[imgIndex].push(obj);

      // dc.forEach((iw, index) => {
      //   iw.sort((a, b) => a["ID"] - b["ID"]);
      // });
      // setMasterData(dc);
      // setBoxes([]);
      // setDraw(false);
    }
    setIsDrawing(false);
    setPpeb(false);
  };

  const processGT = (data) => {
    if (data.length === 1) {
      let obReq = {
        ".X": "",
        ".XX": "",
        ".XXX": "",
        ".XXXX": "",
        ".XXXXX": "",
        "angles": "",
        "fractional": "",
      };
      Object.keys(data[0]).forEach(k => {
        if (k in data[0]) {
          obReq[k] = data[0][k];
        }
      });
      return obReq;
      // return data[0];
    }
    let obGot = JSON.parse(data.replace(/[\n]/g, ''));
    let obReq = {
      ".X": "",
      ".XX": "",
      ".XXX": "",
      ".XXXX": "",
      ".XXXXX": "",
      "angles": "",
      "fractional": "",
    };
    Object.keys(obReq).forEach(k => {
      if (k in obGot) {
        obReq[k] = obGot[k];
      }
    });
    return obReq;
    // return obGot;
  };

  const returnCanvasVal = (val) => {
    const svgElement = svgRef.current;
    const { width, height } = svgElement.getBoundingClientRect();
    if (val === 19.64) {
      return ((width / zoomLevel) * val) / 3400;
    } else if (val === 16.78) {
      return ((height / zoomLevel) * val) / 2200;
    }
  };

  const handleTarget = (e, t, index) => {
    if (del) {
      const clone = [...masterData];
      clone[imgIndex].splice(index, 1);
      setMasterData(clone);
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    setSelectedEllip(t);
  };

  const orderCallouts = () => {
    const clone = [...masterData];
    let start = clone[imgIndex]?.[0]?.["ID"];
    // clone[imgIndex].forEach((sub) => idArr.push(sub["ID"]));
    clone[imgIndex].sort((a, b) => a.bbox[1] - b.bbox[1]);
    // idArr.sort((a, b) => a - b); 
    console.log("Start", start)
    clone[imgIndex].forEach((or, index) => {
      clone[imgIndex][index]["ID"] = start;
      start += 1;
      // console.log(start)
    });
    setMasterData(clone);
  };

  const runGroupAlgo = (par) => {
    if (poly.length === 0) {
      toast.info("Please add region of interest!");
      return;
    }
    const clone = [...masterData];
    let arr1 = [];
    let arr2 = [];
    let arr3 = [];
    let arr4 = [];
    const modPoly = poly.map(({ x, y }) => [x, y]);
    // Extract coordinates
    const xArr = modPoly.map(([x]) => x);
    const yArr = modPoly.map(([_, y]) => y);
    const xmi = Math.min(...xArr);
    const xma = Math.max(...xArr);
    const ymi = Math.min(...yArr);
    const yma = Math.max(...yArr);
    const cen = [(xma + xmi) / 2, (yma + ymi) / 2];

    // Split objects into arr1 and arr2
    clone[imgIndex].forEach(obj => {
      const bboxCorners = [
        [obj.bbox[0], obj.bbox[1]], // bottom-left
        [obj.bbox[2], obj.bbox[1]], // bottom-right
        [obj.bbox[2], obj.bbox[3]], // top-right
        [obj.bbox[0], obj.bbox[3]]  // top-left
      ];

      const isInPolygon = bboxCorners.every(corner => pointInPolygon(corner, modPoly));
      if (isInPolygon) {
        arr2.push(obj);
      } else {
        arr1.push(obj);
      }
    });

    if (par) {
      if (arr2.length > 0) {
        let found = false;
        grouping[imgIndex].forEach(ea => {
          arr2.forEach(eac => {
            if (ea["Ids"].includes(eac["ID"])) found = true;
          })
        })

        if (found) {
          toast.info("Already grouped region!")
          setPoly([])
          return;
        }
        if (par === 'ToD') {
          const toDown = arr2.sort((a, b) => a.bbox[1] - b.bbox[1]);
          const toOrderIds = arr2.map(ea => ea["ID"]).sort((a, b) => a - b);
          toDown.forEach((or, idx) => {
            // or["ID"] = toOrderIds[idx];
            or["ID"] = idx + 1;
          });
          let from = toOrderIds.length + 1;
          arr1.forEach(ea => {
            ea["ID"] = from;
            from += 1;
          })
          const updatedData = [...arr1, ...toDown].sort((a, b) => a["ID"] - b["ID"]);
          clone[imgIndex] = updatedData;
          const temp = [...grouping];
          temp[imgIndex].push({
            count: 1,
            Ids: [...arr2.map(ea => ea["ID"]).sort((a, b) => a - b)],
            pc: poly
          })
          setGrouping(temp)
        }
        else if (par === 'ToU') {
          const toDown = arr2.sort((a, b) => b.bbox[1] - a.bbox[1]);
          const toOrderIds = arr2.map(ea => ea["ID"]).sort((a, b) => a - b);
          toDown.forEach((or, idx) => {
            // or["ID"] = toOrderIds[idx];
            or["ID"] = idx + 1;
          });
          let from = toOrderIds.length + 1;
          arr1.forEach(ea => {
            ea["ID"] = from;
            from += 1;
          })
          const updatedData = [...arr1, ...toDown].sort((a, b) => a["ID"] - b["ID"]);
          clone[imgIndex] = updatedData;
          const temp = [...grouping];
          temp[imgIndex].push({
            count: 1,
            Ids: [...arr2.map(ea => ea["ID"]).sort((a, b) => a - b)],
            pc: poly
          })
          setGrouping(temp)
          console.log("temp", temp)
        }
      }
      setMasterData(clone);
      setPoly([]);
      return
    }

    //Step 1
    if (grouping?.[imgIndex].length === 0) {
      if (arr2.length > 0) {
        const angArr = arr2.map((sub, index) => {
          const bCen = [(sub.bbox[0] + sub.bbox[2]) / 2, (sub.bbox[1] + sub.bbox[3]) / 2];
          let angle = Math.atan2(bCen[1] - cen[1], bCen[0] - cen[0]) * (180 / Math.PI);
          angle = (angle + 180) % 360;
          return { angle, index, bCen };
        });

        // Sort angles and assign IDs
        angArr.sort((a, b) => a.angle - b.angle);
        const toOrderIds = clone[imgIndex].map(ea => ea["ID"]).sort((a, b) => a - b);

        angArr.forEach((or, idx) => {
          arr2[or.index]["ID"] = toOrderIds[idx];
        });

        // Assign remaining IDs to arr1
        const remainingIds = toOrderIds.slice(angArr.length);
        arr1.forEach((sub, idx) => {
          sub["ID"] = remainingIds[idx];
        });
        const temp = [...grouping];
        temp[imgIndex].push({
          count: 1,
          Ids: [...arr2.map(ea => ea["ID"]).sort((a, b) => a - b)],
          pc: poly
        })
        setAngData(angArr);
        setGrouping(temp)
        // Combine, sort, and update data
        const updatedData = [...arr1, ...arr2].sort((a, b) => a["ID"] - b["ID"]);
        clone[imgIndex] = updatedData;
      }
      setMasterData(clone);
      setPoly([]);
    }
    //Step 2
    if (grouping?.[imgIndex].length > 0) {
      if (arr2.length > 0) {
        let found = false;
        // let arar = arr2.map(ea => ea?.["ID"])
        grouping[imgIndex].forEach(ea => {
          arr2.forEach(eac => {
            if (ea["Ids"].includes(eac["ID"])) found = true;
          })
        })

        if (found) {
          toast.info("Already grouped region!")
          setPoly([])
          return;
        }
        const idSet = new Set(grouping[imgIndex].flatMap(eac => eac.Ids));
        arr1.forEach(ea => {
          if (idSet.has(ea["ID"])) {
            arr3.push(ea);
          } else {
            arr4.push(ea);
          }
        });

        let from = Math.max(...arr3.map(ea => ea["ID"]));
        //Don't Touch arr3
        const angArr = arr2.map((sub, index) => {
          const bCen = [(sub.bbox[0] + sub.bbox[2]) / 2, (sub.bbox[1] + sub.bbox[3]) / 2];
          let angle = Math.atan2(bCen[1] - cen[1], bCen[0] - cen[0]) * (180 / Math.PI);
          angle = (angle + 180) % 360;
          return { angle, index, bCen };
        });

        // Sort angles and assign IDs
        angArr.sort((a, b) => a.angle - b.angle);
        angArr.forEach((or, idx) => {
          arr2[or.index]["ID"] = from + 1;
          from += 1;
        });

        arr4.forEach((sub) => {
          sub["ID"] = from + 1;
          from += 1
        });
        const temp = [...grouping];
        temp[imgIndex].push({
          count: grouping[imgIndex].length + 1,
          Ids: [...arr2.map(ea => ea["ID"]).sort((a, b) => a - b)],
          pc: poly
        })
        setGrouping(temp)
        console.log("temp", temp)
        setAngData(angArr)
        const updatedData = [...arr3, ...arr2, ...arr4].sort((a, b) => a["ID"] - b["ID"]);
        clone[imgIndex] = updatedData;
      }
      setMasterData(clone);
      setPoly([]);

    }
  };

  const handleTableData = (e, i) => {
    const clone = [...masterData];
    clone[imgIndex][i] = { ...clone[imgIndex][i], text: e.target.value }
    setMasterData(clone);
  };

  const handleCtqFactor = (e, i) => {
    e.preventDefault();
    const clone = [...masterData];
    if ("ctq" in clone[imgIndex][i]) {
      clone[imgIndex][i]["ctq"] = !clone[imgIndex][i]["ctq"]
    } else {
      clone[imgIndex][i]["ctq"] = false;
    }
    setMasterData(clone);
  };

  const returnCtqBool = (i) => {
    const clone = [...masterData];
    if ("ctq" in clone[imgIndex][i]) {
      return clone[imgIndex][i]["ctq"]
    } else {
      return false;
    }
  };

  const handleCurPos = () => {
    const textArea = textAreaRef.current;
    setCurPos(textArea.selectionStart);
  };

  const handleIconClick = (icon) => {
    if (selKey === null) return;
    let data = [...masterData];
    const textArea = textAreaRef.current;
    const start = textArea.selectionStart;
    const end = textArea.selectionEnd;
    console.log("Start", start, "End", end);
    const before = data[imgIndex]?.[selKey]?.["text"].slice(0, start);
    const after = data[imgIndex]?.[selKey]?.["text"].slice(end);
    const newValue = before + icon + after;
    data[imgIndex][selKey]["text"] = newValue;
    const newCursorPosition = start + icon.length;
    setTimeout(() => {
      textArea.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);
    setMasterData(data);
  };

  const deleteUsingKey = () => {
    // alert("Called1234567890");
    // if (selectedBbox === null) return;
    // alert("Called123456789");
    const clone = [...masterData];
    clone[imgIndex].splice(selectedBbox, 1);
    setMasterData(clone);
  };

  const handleKeyDown = (e) => {
    if (e.ctrlKey && (e.key === 'q' || e.key === 'Q')) {
      e.preventDefault();
      setOpen(true);
    }
    if (e.keyCode === 123) {
      e.preventDefault();
    }   
    if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
      e.preventDefault();
    }
    if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
      e.preventDefault();
    }
    if (e.ctrlKey && e.keyCode === 85) {
      e.preventDefault();
    }
    else if (e.ctrlKey && (e.key === 'd' || e.key === 'D')) {
      e.preventDefault();
      setDraw(val => !val);
    }
    else if (e.ctrlKey && (e.key === 's' || e.key === 'S')) {
      e.preventDefault();
      exportDataBtn.current.click();
    }
    else if (e.ctrlKey && (e.key === 'd' || e.key === 'D')) {
      e.preventDefault();
      if (selKey === null) return;
      const clone = [...masterData];
      const updatedText = clone[imgIndex][selKey].text.split(' ').join('');
      clone[imgIndex][selKey] = { ...clone[imgIndex][selKey], text: updatedText };
      setMasterData(clone);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setSelectedBbox(null);
    }
  };

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    fontFamily: 'Montserrat'
  }));

  const processGroupingData = (data, frames) => {

    if (data.length === 0) {
      let arr = []
      frames.forEach(ea => arr.push([]))
      setGrouping(arr)
      return;
    }
    const svgElement = svgRef.current;
    const { width, height } = svgElement.getBoundingClientRect();
    const wid = width;
    const hei = height;
    const img = new Image();
    img.src = frames[0];
    // img.onload = () => {
    //   setImgOrgDim({
    //     imgWidth: img.width,
    //     imgHeight: img.height
    //   });
    // }

    function scaleCoordinates(poly, width, height, index) {
      const { imgWidth, imgHeight } = imgOrgDimArr[imgIndex];
      let clone = [...poly].map(ea => {
        return {
          ...ea,
          x: (width * ea?.x) / imgWidth,
          y: (height * ea?.y) / imgHeight,
        }
      })
      return clone;
    }

    if (img.width !== 0 && img.height !== 0 && img.width !== undefined && img.height !== undefined && img.width !== null && img.height !== null) {
      const masterGrouping = data.map((list,index) => {
        return list.map((obj) => {
          return {
            ...obj,
            pc: obj.pc ? scaleCoordinates(obj.pc, wid, hei,index) : undefined,
          };
        });
      });

      setGrouping(masterGrouping);
    } else {
      getData();
    }
  }
  const processGroupingDataExport = (data) => {

    if (data.length === 0) return [];

    function scaleCoordinates(poly) {
      let clone = [...poly].map(ea => {
        const { imgWidth, imgHeight } = imgOrgDimArr[imgIndex];
        return {
          ...ea,
          x: (imgWidth * ea?.x) / svgDimi.wid,
          y: (imgHeight * ea?.y) / svgDimi.hei,
        }
      })
      return clone;
    }

    const masterGrouping = data.map((list) => {
      return list.map((obj) => {
        return {
          ...obj,
          pc: obj.pc ? scaleCoordinates(obj.pc) : undefined,
        };
      });
    });
    return masterGrouping;
  }

  async function getOriginalDimensions(frames) {
  const promises = frames.map((src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        resolve({
          imgWidth: img.width,
          imgHeight: img.height
        });
      };
      img.onerror = () => {
        resolve({
          imgWidth: 0,
          imgHeight: 0
        });
      };
    });
  });
  const imgDimArray = await Promise.all(promises);
  console.log("Image Dimensions Array:", imgDimArray);
  return imgDimArray;
}

function scaleCoordinates(coordinate, width, height, imgWidth, imgHeight) {
  return [
    (width * coordinate[0]) / imgWidth,
    (height * coordinate[1]) / imgHeight,
    (width * coordinate[2]) / imgWidth,
    (height * coordinate[3]) / imgHeight
  ];
}

async function processImportData(data, frames) {
  const svgElement = svgRef.current;
  const { width, height } = svgElement.getBoundingClientRect();
  const imgDimArray = await getOriginalDimensions(frames);
  if (!imgDimArray || imgDimArray.length !== frames.length) {
    alert("Image dimensions failed to load. Please reload.");
    return;
  }
setImgOrgDimArr(imgDimArray);
  const masterClone = data.map((list, index) => {
    const { imgWidth, imgHeight } = imgDimArray[index];
    return list.map((obj) => ({
      ...obj,
      bbox: obj.bbox
        ? scaleCoordinates(obj.bbox, width, height, imgWidth, imgHeight)
        : undefined,
      ellips_box: obj.ellips_box
        ? scaleCoordinates(obj.ellips_box, width, height, imgWidth, imgHeight)
        : undefined,
      ctq: obj.ctq === "0" ? false : true
    }));
  });

  const corrected = masterClone.map((list) => {
    return list.map((obj) => {
      if (obj?.bbox?.[3] < obj?.bbox?.[1]) {
        return {
          ...obj,
          bbox: [obj.bbox[0], obj.bbox[3], obj.bbox[2], obj.bbox[1]]
        };
      }
      return obj;
    });
  });
  setMasterData(corrected);
}

useEffect(() => {
  console.log("maasterData", masterData)
}, [masterData])
  const processExportData = (data) => {
    function scaleCoordinates(coordinate,index) {
      const { imgWidth, imgHeight } = imgOrgDimArr[index];
      return [
        (imgWidth * coordinate[0]) / svgDimi.wid,
        (imgHeight * coordinate[1]) / svgDimi.hei,
        (imgWidth * coordinate[2]) / svgDimi.wid,
        (imgHeight * coordinate[3]) / svgDimi.hei
      ];
    }

    // function scalePosition(position, width, height, imgWidth, imgHeight) {
    //   return [
    //     (width * position[0]) / imgWidth,
    //     (height * position[1]) / imgHeight
    //   ];
    // }
    // const masterClone = data.map((obj) => {
    //   return {
    //     ...obj,
    //     bbox: scaleCoordinates(obj.bbox),
    //     ellips_box: scaleCoordinates(obj.ellips_box),
    //     // text_position: scalePosition(obj.text_position, wid, hei, img.width, img.height)
    //   };
    // });

    const masterClone = data.map((list,index) => {

      return list.map((obj) => {
        console.log('ctq value:', obj.ctq);
        return {
          ...obj,
          bbox: obj.bbox ? scaleCoordinates(obj.bbox,index) : undefined,
          ctq: obj.ctq === false ? "0" : "1",
          ellips_box: obj.ellips_box ? scaleCoordinates(obj.ellips_box,index) : undefined,
          // text_position: obj.text_position ? scalePosition(obj.text_position) : undefined
        };

      });
    });
    return masterClone;
  };

  const handleDeleteUiBtn = (e) => {
    console.log('Selected Bounding Box Index:', selectedBbox);
    console.log('Selected Ellipse Index:', selectedEllip);
    if ((selectedBbox !== null || selectedEllip !== null) && masterData.length > 0) {
      const clone = [...masterData];
      if (selectedBbox !== null) {
        console.log('Deleting Bounding Box at index:', selectedBbox);
        clone[imgIndex].splice(selectedBbox, 1);
        setSelectedBbox(null);
      }
      if (selectedEllip !== null) {
        console.log('Deleting Ellipse at index:', selectedEllip);
        clone[imgIndex].splice(selectedEllip, 1);
        setSelectedEllip(null);
      }
      setMasterData(clone);
    }
  };

  const returnPagesIcon = (wh) => {
    if (masterData !== null && masterData !== undefined && masterData.length > 0) {
      if (wh === "cur") {
        const icon = numberIcons[imgIndex + 1];
        return icon ? icon : null;
      } else if (wh === "tot") {
        const icon = numberIcons[masterData.length];
        return icon ? icon : null;
      }
    }
    return null;
  };

  const handleNextImage = () => {
    if (imgIndex < fileList.length - 1) {
      const nextIndex = imgIndex + 1;
      // let arr = [];
      // arr[imgIndex] = [...grouping];
      // setWholeGroup(arr);
      setImgIndex(nextIndex);
      setImgSource1(fileList[nextIndex]);
      // setGrouping([]);
    } else {
      alert("End of frame List");
    }
  };

  const handlePreviousImage = () => {
    if (imgIndex > 0) {
      const prevIndex = imgIndex - 1;
      setImgIndex(prevIndex);
      setImgSource1(fileList[prevIndex]);
    } else {
      alert("Displaying first frame");
    }
  };
  const getData = () => {
    const locationState = props.location.state;
    const [part1, part2] = locationState.split(":");
    toast.promise(
      axios
        .get(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/${part2}/${part1}/`, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
          }
        }),
      {
        pending: 'Fetching Data..!',
        // success: 'Frames Retrieved..'
      }
    )
      .then((response) => {
        console.log("Response from B", response.data)
        setFileList(response.data.msg.urls);
        setLoading(false);
        processImportData(response.data.msg.data, response.data.msg.urls);
        setFullData(response.data.msg.data);
        setGloTol(processGT(response.data.msg.global_tolerance));
        processGroupingData([], response.data.msg.urls);
      })
      .catch((err) => {
        alert("Failed to load data!");
        console.log(err)
      })
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    console.log("Grouping ", grouping)
  }, [grouping]);

  useEffect(() => {
    const handleDelete = (e) => {
      if (e.key === 'Delete' && selectedBbox !== null && selectedEllip !== null) {
        e.preventDefault();
        const clone = [...masterData];
        clone[imgIndex].splice(selectedBbox, 1);
        let start = 1;
        clone.forEach((sub) => {
          sub.forEach((obj) => {
            // if (obj["ID"] > selectedBbox) {
            obj["ID"] = start;
            start++
            // }
          })
        })
        setMasterData(clone);
        setSelectedBbox(null);
        setSelectedEllip(null);
        setSelectedRow(null);
      }
    }
    document.addEventListener('keydown', handleDelete);
    return () => {
      document.removeEventListener('keydown', handleDelete);
    };
  }, [selectedBbox, selectedRow]);

  useEffect(() => {
    const handleDelete = (e) => {
      if (e.key === 'Delete' && selectedEllip !== null) {
        e.preventDefault();
        const clone = [...masterData];
        clone[imgIndex].splice(selectedEllip, 1);
        setMasterData(clone);
        setSelectedBbox(null);
        setSelectedEllip(null);
      }
    }
    document.addEventListener('keydown', handleDelete);
    return () => {
      document.removeEventListener('keydown', handleDelete);
    };
  }, [selectedEllip]);

  useEffect(() => {
    function handleResize() {
      if (svgDimi.wid !== 0 && svgDimi.hei !== 0 && svgRef && svgRef.current && masterData.length > 0) {
        setSelectedEllip(null);
        setSelectedBbox(null);
        const svgElement = svgRef.current;
        const { width, height } = svgElement.getBoundingClientRect();
        const wid = width;
        const hei = height;
        function scaleCoordinates(coordinate, width, height, imgWidth, imgHeight) {
          return [
            (width * coordinate[0]) / (imgWidth * zoomLevel),
            (height * coordinate[1]) / (imgHeight * zoomLevel),
            (width * coordinate[2]) / (imgWidth * zoomLevel),
            (height * coordinate[3]) / (imgHeight * zoomLevel)
          ];
        }
        // function scalePosition(position, width, height, imgWidth, imgHeight) {
        //   return [
        //     (width * position[0]) / (imgWidth * zoomLevel),
        //     (height * position[1]) / (imgHeight * zoomLevel)
        //   ];
        // }

        const masterClone = masterData.map((list) => {
          return list.map((obj) => {
            return {
              ...obj,
              bbox: obj.bbox ? scaleCoordinates(obj.bbox, wid, hei, svgDimi.wid, svgDimi.hei) : undefined,
              ellips_box: obj.ellips_box ? scaleCoordinates(obj.ellips_box, wid, hei, svgDimi.wid, svgDimi.hei) : undefined,
              // text_position: obj.text_position ? scalePosition(obj.text_position, wid, hei, img.width, img.height) : undefined
            };
          });
        });
        if (poly.length > 0) {
          const polyClone = poly.map(({ x, y }) => {
            return {
              x: (wid * x) / (svgDimi.wid * zoomLevel),
              y: (hei * y) / (svgDimi.hei * zoomLevel)
            };
          });
          setPoly(polyClone);
        }
        setMasterData(masterClone);
        setSvgDimi({ wid: wid / zoomLevel, hei: hei / zoomLevel });
      }
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [svgRef, zoomLevel, svgDimi.wid, svgDimi.hei, jsonData1, fileList]);

  // Try 2 if processImportData not working for variable img dimensions
  // useEffect(() => {
  //   function handleResize() {
  //     if (svgDimi.wid !== 0 && svgDimi.hei !== 0 && svgRef && svgRef.current && masterData.length > 0) {
  //       setSelectedEllip(null);
  //       setSelectedBbox(null);
  //       const svgElement = svgRef.current;
  //       const { width, height } = svgElement.getBoundingClientRect();
  //       const wid = width;
  //       const hei = height;

  //       function scaleCoordinates(coordinate, width, height, imgWidth, imgHeight) {
  //         return [
  //           (width * coordinate[0]) / (imgWidth * zoomLevel),
  //           (height * coordinate[1]) / (imgHeight * zoomLevel),
  //           (width * coordinate[2]) / (imgWidth * zoomLevel),
  //           (height * coordinate[3]) / (imgHeight * zoomLevel)
  //         ];
  //       }

  //       const masterClone = masterData.map((list) => {
  //         return list.map((obj) => {
  //           return {
  //             ...obj,
  //             bbox: obj.bbox ? scaleCoordinates(obj.bbox, wid, hei, svgDimi.wid, svgDimi.hei) : undefined,
  //             ellips_box: obj.ellips_box ? scaleCoordinates(obj.ellips_box, wid, hei, svgDimi.wid, svgDimi.hei) : undefined,
  //             // text_position: obj.text_position ? scalePosition(obj.text_position, wid, hei, img.width, img.height) : undefined
  //           };
  //         });
  //       });
  //       if (poly.length > 0) {
  //         const polyClone = poly.map(({ x, y }) => {
  //           return {
  //             x: (wid * x) / (svgDimi.wid * zoomLevel),
  //             y: (hei * y) / (svgDimi.hei * zoomLevel)
  //           };
  //         });
  //         setPoly(polyClone);
  //       }
  //       setMasterData(masterClone);
  //       setSvgDimi({ wid: wid / zoomLevel, hei: hei / zoomLevel });
  //     }
  //   }
  //   window.addEventListener('resize', handleResize);
  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, [imgIndex]);

  useEffect(() => {
    function goGreenZoom() {
      setZoomBoolean(false);
    }
    document.addEventListener("keyup", goGreenZoom);
    return () => {
      document.removeEventListener("keyup", goGreenZoom);
    };
  }, []);

  useEffect(() => {
    if (fileList.length > 0) {
      setImgIndex(0);
      setImgSource1(fileList[0]);

      // setImgName(fileList[imgIndex].name.toString());
    }
  }, [fileList]);

  // useEffect(() => {
  //   if (jsonFile.length > 0) {
  //     const file = new FileReader();
  //     file.onload = (e) => {
  //       const json = JSON.parse(e.target.result);
  //       setJsonData(json)
  //     }
  //     file.readAsText(jsonFile[0]);
  //   }
  // }, [jsonFile]);

  useEffect(() => {
    function handlePanning(event) {
      if (event.button === 0 || event.button === 2) {
        setPanning({ disabled: true });
      }
      if (event.button === 1) {
        setPanning({ disabled: false });
        svgRef.current.style.cursor = "grab";
      }
    }
    document.addEventListener("mousedown", handlePanning);
    return () => {
      document.removeEventListener("mousedown", handlePanning);
    };
  }, []);

  useEffect(() => {
    function handleCursorStyle(event) {
      svgRef.current.style.cursor = "default";
    }
    document.addEventListener("mouseup", handleCursorStyle);
    return () => {
      document.removeEventListener("mouseup", handleCursorStyle);
    };
  }, []);


  useEffect(() => {
    const svgElement = svgRef.current;
    const { width, height } = svgElement.getBoundingClientRect();
    setSvgDimi({ wid: width, hei: height });
  }, []);

  useEffect(() => {
    if (draw) {
      setEdit(false);
      setDel(false);
      setGroup(false);
    }
  }, [draw]);

  // useEffect(() => {
  //   if (edit) {
  //     setDraw(false);
  //     setDel(false);
  //     setGroup(false);
  //   }
  // }, [edit]);

  useEffect(() => {
    if (del) {
      setEdit(false);
      setDraw(false);
      setGroup(false);
    }
  }, [del]);

  useEffect(() => {
    if (group) {
      setEdit(false);
      setDraw(false);
      setDel(false);
    }
  }, [group]);



  useEffect(() => {
    toast.promise(
      axios
        .get(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/onetask/${taskId}/`, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
          }
        }),
      {

        pending: 'Fetching Data..!',
        // success: 'Frames Retrieved..'
      }
    )

      .then((response) => {
        console.log("Response from B", response.data)
        setFileList(response.data.msg.urls);
        setLoading(false);
        processImportData(response.data.msg.data, response.data.msg.urls);
        setFullData(response.data.msg.data);
        setGloTol(processGT(response.data.msg.global_tolerance));
        processGroupingData([], response.data.msg.urls);
        // console.log(response.data);
        // console.log(typeof processGT(response.data.glo_tol));
      })

      .catch((err) => {
        alert("Failed to load data!");
      })
  }, []);

  useEffect(() => {
    const handleUserActivity = () => {
      setLastActivity(Date.now());
      if (!isRunning) {
        setIsRunning(true);
      }
    };
    document.addEventListener('mousedown', handleUserActivity);
    document.addEventListener('keydown', handleUserActivity);
    const activityInterval = setInterval(() => {
      if (isRunning && lastActivity) {
        const currentTime = Date.now();
        if (currentTime - lastActivity > 19000) {
          setIsRunning(false);
          setPausedSeconds(seconds);
        }
      }
    }, 1000);

    return () => {
      document.removeEventListener('mousedown', handleUserActivity);
      document.removeEventListener('keydown', handleUserActivity);
      clearInterval(activityInterval);
    };

  }, [isRunning, lastActivity, seconds]);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      if (isRunning) {
        setSeconds(prevSeconds => prevSeconds + 1);
      }
    }, 1000);
    return () => {
      clearInterval(timerInterval);
    };

  }, [isRunning]);

  useEffect(() => {
    function handleContextMenu(e) {
      e.preventDefault();
    }
    const rootElement = document.getElementById('my-component');
    rootElement.addEventListener('contextmenu', handleContextMenu);
    return () => {
      rootElement.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  const handleSnapping = (e) => {
    if (!draw && dragging !== null) {
      const svgElement = svgRef.current;
      const { left, top, width: svgWidth, height: svgHeight } = svgElement.getBoundingClientRect();
      const dataClone = [...masterData];
      let newX = (e.clientX - left) / zoomLevel - mouseOffset.x;
      let newY = (e.clientY - top) / zoomLevel - mouseOffset.y;

      let boxWidth = dataClone[imgIndex][dragging].bbox[2] - dataClone[imgIndex][dragging].bbox[0];
      let boxHeight = dataClone[imgIndex][dragging].bbox[3] - dataClone[imgIndex][dragging].bbox[1];


      switch (handleDrag) {
        case "top-left":
          newX = Math.max(newX, 0);
          newY = Math.max(newY, 0);
          dataClone[imgIndex][dragging].bbox[0] = newX;
          dataClone[imgIndex][dragging].bbox[1] = newY;
          break;

        case "top-right":
          newY = Math.max(newY, 0);
          const topRightX = Math.min((e.clientX - left) / zoomLevel, svgWidth / zoomLevel);
          dataClone[imgIndex][dragging].bbox[1] = newY;
          dataClone[imgIndex][dragging].bbox[2] = topRightX;
          break;

        case "bottom-left":
          newX = Math.max(newX, 0);
          const bottomLeftY = Math.min((e.clientY - top) / zoomLevel, svgHeight / zoomLevel);
          dataClone[imgIndex][dragging].bbox[0] = newX;
          dataClone[imgIndex][dragging].bbox[3] = bottomLeftY;
          break;

        case "bottom-right":
          const bottomRightX = Math.min((e.clientX - left) / zoomLevel, svgWidth / zoomLevel);
          const bottomRightY = Math.min((e.clientY - top) / zoomLevel, svgHeight / zoomLevel);
          dataClone[imgIndex][dragging].bbox[2] = bottomRightX;
          dataClone[imgIndex][dragging].bbox[3] = bottomRightY;
          break;

        case "bb-drag":
          newX = Math.max(0, Math.min(newX, svgWidth / zoomLevel - boxWidth));
          newY = Math.max(0, Math.min(newY, svgHeight / zoomLevel - boxHeight));
          dataClone[imgIndex][dragging].bbox[0] = newX;
          dataClone[imgIndex][dragging].bbox[1] = newY;
          dataClone[imgIndex][dragging].bbox[2] = newX + boxWidth;
          dataClone[imgIndex][dragging].bbox[3] = newY + boxHeight;
          break;

        default:
          break;
      }

      // Adjust for negative width and height (this is key to preventing negative values)
      if (boxWidth < 0) {
        // Swap left and right coordinates
        const temp = dataClone[imgIndex][dragging].bbox[0];
        dataClone[imgIndex][dragging].bbox[0] = dataClone[imgIndex][dragging].bbox[2];
        dataClone[imgIndex][dragging].bbox[2] = temp;
        boxWidth = -boxWidth;
      }
      if (boxHeight < 0) {
        // Swap top and bottom coordinates
        const temp = dataClone[imgIndex][dragging].bbox[1];
        dataClone[imgIndex][dragging].bbox[1] = dataClone[imgIndex][dragging].bbox[3];
        dataClone[imgIndex][dragging].bbox[3] = temp;
        boxHeight = -boxHeight;
      }
      setMasterData(dataClone);
    }
  };

  return (
    <div id="my-component" className="h-screen w-full bg-slate-200" >
      <div className="bg-gradient-to-r from-[#0c8c8f] via-[#155e63] to-[#0e4749]  flex justify-between w-full" style={{ height: "5vh" }}>
        <div className="w-1/3 flex justify-start">
          {/* Timer */}
          <div className="flex justify-center text-xl font-bold  p-2 text-white  mt-3 mx-2">{`${Math.floor(seconds / 3600)
            .toString()
            .padStart(2, '0')}:${Math.floor((seconds % 3600) / 60)
              .toString()
              .padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`}
          </div>
        </div>
        <div className="w-1/3 flex justify-center">
          <Div style={{ background: 'transparent', color: 'white', fontSize: 40 }} className="title text-center flex justify-center items-center">{"OCR"}</Div>
        </div>
        <div className="w-1/3 flex justify-end gap-6">
          <Tooltip title="Help " placement="top" className="p-2">
            <button onClick={toggleModal} className="text-white text-2xl font-semibold hover:text-orange-500">
              <MdLiveHelp fontSize={40} />
            </button>
          </Tooltip>
          {isModalOpen1 && (
            <div id="apple" className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 " onClick={handleClickOutside1}>
              <div className="bg-white p-8 rounded-lg shadow-lg w-96 h-80 ">
                <h2 className="text-xl font-bold mb-4 flex justify-center"> Shortcuts Keys</h2>
                <div className="flex justify-center  gap-y-4 ">
                  <ul className="list-disc list-inside ">
                    <li><strong>Ctrl+s</strong> :- Save</li>
                    <li><strong>Ctrl+m</strong> :- Merge</li>
                    <li><strong>Ctrl+q</strong> :- Symbols </li>
                    <li><strong>Ctrl+z</strong> :- Undo </li>
                    <li><strong>Ctrl+d</strong> :- Draw On </li>
                    <li><strong>Delete Button</strong> </li>
                    <li><strong>Right Click  </strong>:- Delete (callouts Row) </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          <Tooltip title="Tasks " placement="top" className="p-2 gap-2">
            <button onClick={() => history.push("/task")} ref={addDataBtn} className="text-white text-2xl font-semibold hover:text-orange-500">
              <FaTasks fontSize={40} />
            </button>
          </Tooltip>
          <Tooltip title="save " placement="top" className="p-2 gap-2">
            <button onClick={() => saveJsonData()} ref={exportDataBtn} className="text-white text-2xl font-semibold hover:text-orange-500">
              <IoIosSave fontSize={40} />
            </button>
          </Tooltip>
          <Tooltip title="submit " placement="top" className="p-2 mb-2">
            <button onClick={() => handleOpenModal()} className="text-white text-2xl font-semibold hover:text-orange-500">
              <CiExport fontSize={40} />
            </button>
          </Tooltip>
          <Tooltip title="blank" placement="top" className="p-2   ">
            <button onClick={blankJsonData} className="text-white text-2xl font-semibold hover:text-orange-500">
              <PiNoteBlankLight fontSize={40} />
            </button>
          </Tooltip>
          <Tooltip title="Logout " placement="top" className="p-2 ">
            <button
              onClick={() => {
                sessionStorage.clear();
                window.location.reload()
              }}
              className="text-white text-2xl font-semibold hover:text-orange-500">
              <IoLogOut fontSize={40} />
            </button>
          </Tooltip>
        </div>
      </div>
      <div className="flex w-fit" style={{ height: "92vh" }} >
        <div className="w-3/4 " onMouseMove={(e) => handleSnapping(e)}>
          <div className="bg-slate-100 p-2 gap-2 border-2 border-black" style={{ height: "87vh" }}>
            <TransformWrapper
              ref={transformWrapperRef}
              maxScale={60}
              minScale={1}
              panning={panning}
              wheel={{ step: stepValue, disabled: zoomBoolean }}
              velocityAnimation={{ disabled: true }}
              disablePadding={true}
              onTransformed={handleTransform}
              doubleClick={{ disabled: true }}
              zoomAnimation={{ animationType: 'easeOut' }}
            >
              <TransformComponent className="p-2 gap-2" contentStyle={{ height: "86vh", width: "74vw" }}>
                <svg
                  ref={svgRef}
                  id="svg-container-id"
                  style={{ height: "86vh", width: "74vw", imageRendering: "auto" }}
                  onMouseDown={(e) => handleAddballooning(e)}
                  onMouseMove={(e) => handlePositionChange(e)}
                  onMouseUp={() => handleRelease()}
                  onMouseLeave={() => setAxisLine({ x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0, x4: 0, y4: 0 })}
                  onClick={(e) => handleGrouping(e)}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    setSelectedEllip(null);
                    setSelectedBbox(null);
                    setGroup(false);
                  }}
                >
                  {selectedBbox && (
                    <rect
                      x={selectedBbox.x}
                      y={selectedBbox.y}
                      width={Math.abs(selectedBbox.width)}
                      height={Math.abs(selectedBbox.height)}
                      fill="none"
                      stroke="blue"
                      strokeDasharray="5,5"
                    />
                  )}
                  {selectedEllip && (
                    <ellipse
                      fill="none"
                      stroke="blue"
                      strokeDasharray="5,5"

                    />
                  )
                  }
                  <foreignObject
                    className="w-full h-full"
                    style={{
                      pointerEvents: "none",
                      height: '86vh',
                      width: '74vw'
                    }}
                  >
                    {loading ? <div className="w-full h-full flex justify-center items-center"><LoadingIcons.Oval width={150} height={80} stroke='black' /></div> : <img
                      className="w-full h-full"
                      src={imgSource1}
                      alt="Image"
                      style={{
                        pointerEvents: 'none',
                        height: '86vh',
                        width: '74vw',
                        // border: '3px solid black',
                      }}
                      id="segment-image"
                    />}
                  </foreignObject>

                  {masterData !== undefined && masterData !== null && masterData.length > 0 && masterData[imgIndex].map((b, index) => (
                    <g>
                      <rect x={b?.bbox[0]} y={b?.bbox[1]} width={b?.bbox[2] - b?.bbox[0]} height={b?.bbox[3] - b?.bbox[1]} fill='white' stroke={selectedBbox === index ? 'blue' : 'lightgreen'} strokeWidth={zoomLevel === 1 ? 2 : 3 / zoomLevel} fillOpacity={0.01} onMouseDown={(e) => handleRectMouseDown(e, index, "bb-drag")} />
                      {/* <circle cx={b?.ellips_box[0]} cy={b?.ellips_box[1]} fill='none' stroke='red' /> */}
                      <text x={(b?.ellips_box[0] + ((b?.ellips_box[2] - b?.ellips_box[0]) / 2))} y={(b?.ellips_box[1] + ((b?.ellips_box[3] - b?.ellips_box[1]) / 2)) + 2} text-anchor="middle" alignment-baseline="middle" fill="red" style={{ fontSize: '12px' }}>{b?.ID}</text>
                      {/* {angData.length > 0 && angData.map((ang, index) => (
                        <g>
                          <line x1={masterData[imgIndex][index]?.["bbox"][0] + ang?.[2]?.[1]} y1={masterData[imgIndex][index]?.["bbox"][1] + ang?.[2]?.[1]} x2={polCen?.[0]} y2={polCen?.[1]} style={{ stroke: 'red', strokeWidth: '0.4px' }} />
                          <text x={masterData[imgIndex][index]?.["bbox"][0] + ang[2][0]} y={masterData[imgIndex][index]?.["bbox"][1] + ang[2][1]} text-anchor="middle" alignment-baseline="middle" fill="red" style={{ fontSize: '12px' }}>{ang?.[0]}</text>
                        </g>))
                      } */}
                      {grouping
                        && grouping?.[imgIndex].length > 0 && grouping?.[imgIndex].map((gr, index) => (
                          <g>
                            <text x={gr?.["pc"]?.[0]?.x} y={gr?.["pc"]?.[0]?.y} text-anchor="middle" alignment-baseline="middle" fill="blue" style={{ fontSize: '12px' }}>Group{gr?.count}</text>
                          </g>))
                      }

                      <ellipse rx={(b?.ellips_box[2] - b?.ellips_box[0]) / 2} ry={(b?.ellips_box[3] - b?.ellips_box[1]) / 2} cx={b?.ellips_box[0] + ((b?.ellips_box[2] - b?.ellips_box[0]) / 2)} cy={b?.ellips_box[1] + ((b?.ellips_box[3] - b?.ellips_box[1]) / 2)} fill='white' fillOpacity={0.1} stroke={selectedBbox === index ? 'blue' : 'red'}
                        onMouseDown={(e) => handleTarget(e, index, "none")}
                      // onMouseDown={(e) => handleEllipseMouseDown(e, index, "none")}
                      />
                      <defs>
                        <marker id="smallArrow" markerWidth="5" markerHeight="5" refX="3.5" refY="2" orient="auto">
                          <path d="M0,1 L0,3 L4,2 z" fill="blue" />
                        </marker>
                      </defs>
                      <line x1={b?.bbox[0] + ((b?.bbox[2] - b?.bbox[0]) / 2)} y1={b?.bbox[1]} x2={b?.ellips_box[0] + ((b?.ellips_box[2] - b?.ellips_box[0]) / 2)} y2={b?.ellips_box[3]} style={{ strokeWidth: '1px', cursor: 'nwse-resize' }} stroke={selectedBbox === index ? 'blue' : 'red'} marker-end="url(#smallArrow)" onMouseDown={(e) => handleTarget(e, index, "none")} />
                      {selectedBbox === index && <g>
                        <circle
                          cx={b?.bbox[0]}
                          cy={b?.bbox[1]}
                          r={zoomLevel == 1 ? 3 : 2 / (zoomLevel * 0.55)}
                          fill='red'
                          onMouseDown={(e) => handleRectMouseDown(e, index, "top-left")}
                          style={{ cursor: 'nwse-resize' }}
                        />
                        <circle
                          cx={b?.bbox[0] + b?.bbox[2] - b?.bbox[0]} height={b?.bbox[3] - b?.bbox[1]}
                          cy={b?.bbox[1]}
                          r={zoomLevel == 1 ? 3 : 2 / (zoomLevel * 0.55)}
                          // fill={(masterDataHjf[imgIndex][Object.keys(masterDataHjf[imgIndex])[0]].annotations[0].bbox.points[index].Class === curRectIndexData.Class && masterDataHjf[imgIndex][Object.keys(masterDataHjf[imgIndex])[0]].annotations[0].bbox.points[index].Id === curRectIndexData.Id) ? 'red' : 'lightgreen'}
                          onMouseDown={(e) => handleRectMouseDown(e, index, "top-right")}
                          fill='red'
                          style={{ cursor: 'nesw-resize' }}
                        />
                        <circle
                          cx={b?.bbox[0]}
                          cy={b?.bbox[1] + b?.bbox[3] - b?.bbox[1]}
                          r={zoomLevel == 1 ? 3 : 2 / (zoomLevel * 0.55)}
                          // fill={(masterDataHjf[imgIndex][Object.keys(masterDataHjf[imgIndex])[0]].annotations[0].bbox.points[index].Class === curRectIndexData.Class && masterDataHjf[imgIndex][Object.keys(masterDataHjf[imgIndex])[0]].annotations[0].bbox.points[index].Id === curRectIndexData.Id) ? 'red' : 'lightgreen'}
                          onMouseDown={(e) => handleRectMouseDown(e, index, "bottom-left")}
                          fill='red'
                          style={{ cursor: 'nesw-resize' }}
                        />
                        <circle
                          cx={b?.bbox[0] + b?.bbox[2] - b?.bbox[0]} height={b?.bbox[3] - b?.bbox[1]}
                          cy={b?.bbox[1] + b?.bbox[3] - b?.bbox[1]}
                          r={zoomLevel == 1 ? 3 : 2 / (zoomLevel * 0.55)}
                          // fill={(masterDataHjf[imgIndex][Object.keys(masterDataHjf[imgIndex])[0]].annotations[0].bbox.points[index].Class === curRectIndexData.Class && masterDataHjf[imgIndex][Object.keys(masterDataHjf[imgIndex])[0]].annotations[0].bbox.points[index].Id === curRectIndexData.Id) ? 'red' : 'lightgreen'}
                          onMouseDown={(e) => handleRectMouseDown(e, index, "bottom-right")}
                          fill='red'
                          style={{ cursor: 'nwse-resize' }}
                        />

                      </g>}
                    </g>
                  ))}
                  {boxes.length > 0 && boxes.map((box, index) => (
                    <g>
                      <rect
                        x={box.x}
                        y={box.y}
                        width={box.width}
                        height={box.height}
                        fill='white'
                        stroke={selectedBbox === index ? 'blue' : 'lightgreen'}
                        fillOpacity={0.01}
                        strokeWidth={zoomLevel === 1 ? 2 : 3 / zoomLevel}
                      />

                    </g>
                  ))}

                  {poly.length > 0 &&
                    <g>
                      <polygon
                        // key={index}
                        className="polygon"
                        points={poly.map((point) => `${point.x},${point.y}`).join(" ")}
                        // onClick={(e) => handlePolygonClick(index, e)}
                        fill="none"
                        // strokeOpacity='100%'
                        // fill={getRandomColor()}
                        fillOpacity={0.4}
                        stroke="red"
                        strokeWidth={1.5 / (zoomLevel)}
                      // style={{ visibility: colorVisibility[polygon.color] ? "hidden" : "visible" }}
                      // style={{ visibility: polygon.vis ? "visible" : "hidden" }}
                      // style={visorHid()}
                      // visibility={displayNoneorwhat(index)}
                      />

                      {/* {(polygon.points.length !== 0 && polygon.points.length !== 0 && showId) &&
                        <text x={polygon.points[0].x} y={polygon.points[0].y} fill={polygon.color}>{polygon.Id && polygon.Id}</text>
                      } */}
                    </g>
                    // ))
                  }

                  {poly.length > 0 && poly.map((point, index) => (<g>
                    <circle
                      cx={point.x}
                      cy={point.y}
                      r={zoomLevel == 1 ? 3 : 2 / (zoomLevel * 0.55)}
                      // fill={(masterDataHjf[imgIndex][Object.keys(masterDataHjf[imgIndex])[0]].annotations[0].bbox.points[index].Class === curRectIndexData.Class && masterDataHjf[imgIndex][Object.keys(masterDataHjf[imgIndex])[0]].annotations[0].bbox.points[index].Id === curRectIndexData.Id) ? 'red' : 'lightgreen'}
                      onMouseDown={(e) => handlePolyPointEdit(e, index)}
                      fill='blue'
                    // style={{ cursor: edit ? 'nesw-resize' : 'default' }}
                    />
                    {/* {(polygon.points.length !== 0 && polygon.points.length !== 0 && showId) &&
                        <text x={polygon.points[0].x} y={polygon.points[0].y} fill={polygon.color}>{polygon.Id && polygon.Id}</text>
                      } */}
                  </g>))
                    // ))
                  }
                </svg>
              </TransformComponent>
            </TransformWrapper>
          </div>
          <div className="bg-gradient-to-r from-[#0c8c8f] via-[#155e63] to-[#0e4749]  border-4 flex justify-between items-center" style={{ height: "8vh" }}>
            <div className="flex p-4 gap-4 justify-between w-1/4">
              <Tooltip title="Add Ballooning" placement="top"><button onClick={() => {
                setDraw(!draw);
                if (!draw) setSelectedBbox(null);
              }} className={`
                ${draw ? 'bg-orange-500' : 'bg-gray-200'}  hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500  focus:ring-opacity-50  p-3 rounded-lg  transition duration-30 ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-centeritems-center
               `}
                style={{ outline: 'none' }}><IoBalloonOutline fontSize={20} /></button></Tooltip>
              <Tooltip title="ROI" placement="top"><button onClick={() => setGroup(!group)}
                className={`
              ${group ? 'bg-orange-500' : 'bg-gray-200'}  hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500  focus:ring-opacity-50  p-3 rounded-lg  transition duration-30 ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-centeritems-center
             `}
                style={{ outline: 'none' }}><TbPolygon fontSize={20} /></button></Tooltip>
              <Tooltip title="Delete" placement="top"><button onClick={(e) => handleDeleteUiBtn(e, del)}
                className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}
                style={{ outline: 'none' }}
              ><AiOutlineDelete fontSize={20} /></button></Tooltip>

              <Tooltip title="Group" placement="top"><button onClick={() => runGroupAlgo()} className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}
                style={{ outline: 'none' }}><RxGroup fontSize={20} /></button></Tooltip>
              <Tooltip title="Order" placement="top"><button onClick={() => orderCallouts()} className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}
                style={{ outline: 'none' }}><IoReorderFour fontSize={20} /></button></Tooltip>
              <Tooltip title="Ascending" placement="top"><button onClick={() => runGroupAlgo('ToD')} className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}
                style={{ outline: 'none' }}><IoArrowDownOutline fontSize={20} /></button></Tooltip>
              <Tooltip title="Descending" placement="top"><button onClick={() => runGroupAlgo('ToU')} className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}
                style={{ outline: 'none' }}><IoArrowUpOutline fontSize={20} /></button></Tooltip>
              {/* <Tooltip title="Undo" placement="Undo"><button onClick={handleUndo} disabled={polyHistory.length === 0} className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}
                style={{ outline: 'none' }}><IoIosUndo  fontSize={20} /></button></Tooltip> */}
              <button className={` bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center`} onClick={handleUndo} disabled={polyHistory.length === 0}><IoIosUndo fontSize={20} /></button>
            </div>
            <div className="flex justify-center items-center border-sky-700 h-3  gap-4 p-2">
              <div className="p-4 mx-2  text-xl ">
                <strong className='text-white'> ID:{taskId}</strong>
              </div>
              <Tooltip title="Initial Frame" placement="top" className={` bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}><button onClick={() => {
                  setImgIndex(0);
                  setImgSource1(fileList[0]);
                }}><FaFastBackward /></button></Tooltip>
              {/* <Tooltip title="Step Backward" placement="top"><button ref={prevStepImgBtn} onClick={handlepreviousframebystep}> <FaBackward /></button></Tooltip> */}
              <Tooltip title="Previous Frame" placement="top" className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}><button ref={prevImgBtn} onClick={handlePreviousImage}><FaStepBackward /></button></Tooltip>
              <Tooltip title="Pages" placement="top" className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}><button>{returnPagesIcon("cur")}<RxDividerVertical />{returnPagesIcon("tot")}</button></Tooltip>
              <Tooltip title="Next Frame" placement="top" className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}><button ref={nxtImgBtn} onClick={handleNextImage}><FaStepForward /></button></Tooltip>
              {/* <Tooltip title="Step Forward" placement="top"><button ref={nextStepImgBtn} onClick={handlenextframebystep}><FaForward /></button></Tooltip> */}
              <Tooltip title="Last Frame" placement="top" className={`bg-gray-200 hover:bg-orange-500 focus:outline-none   focus:ring-2 focus:ring-orange-500   focus:ring-opacity-50  p-3  rounded-lg  transition  duration-300  ease-in-out  transform  hover:scale-105  active:scale-95  shadow-md  hover:shadow-lg flex justify-center items-center
               `}><button onClick={() => {
                  setImgIndex(fileList?.length - 1);
                  setImgSource1(fileList[fileList?.length - 1]);
                }}><FaFastForward /></button></Tooltip>
            </div>
          </div>
        </div>

        <div style={{ height: "88vh", width: "25vw" }} onMouseEnter={(e) => setSelectedBbox(null)}>
          <div className="gap-8 flex items-center border-slate-400 bg-slate-50">
            <div className="flex w-full overflow-y-scroll scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-400 scrollbar-track-gray-200" style={{ height: "12vh" }}>
              <table className="table-auto w-full" style={{ height: "14vh" }}>
                <thead className="w-full sticky top-0 z-50 bg-gradient-to-r from-[#0c8c8f] via-[#155e63] to-[#0e4749]  text-white">
                  <th className=" flex justify-center w-1/7 p-2">Key
                    <div className="mt-1 ml-8"
                      onClick={handlePlus}
                    ><FaPlus /></div> </th>
                  <th className="w-1/7 p-2">Value</th>
                  <th className="w-1/7 p-2">Delete</th>
                </thead>
                <tbody className="w-full overflow-y-auto scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-400 scrollbar-track-gray-200" style={{ maxHeight: "6vh" }}>
                  {gloTol && Object.keys(gloTol).map((key, index) => (
                    <tr key={index} className="w-full hover:bg-slate-100 justify-center items-center bg-white">
                      <td className="w-1/8 border border-y text-center">
                        {key}
                      </td>
                      <td className="w-1/8 border border-y text-center">
                        {/* {data[key]} */}
                        <input
                          type="text"
                          value={gloTol[key]}
                          onMouseEnter={() => setSelKey(index)}
                          // onKeyDown={preventFirstCharEdit}
                          onChange={e => handleValueChange(key, e.target.value)}
                          className="w-full text-center"
                        />
                      </td>
                      <td className="w-1/8 border border-y text-center text-2xl">
                        <MdDeleteOutline onClick={() => handleDelete(key, index)} className="cursor-pointer  ml-10" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {isModalOpens && (
                <div id="orange" className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center" onClick={handleClickOutside}>
                  <div className="bg-white p-4 rounded-lg w-1/3">
                    <h2 className="text-xl mb-4">Restore Deleted Rows</h2>
                    <ul>
                      {deletedRows.map((row, index) => (
                        <li
                          key={index}
                          className="cursor-pointer hover:bg-gray-200 p-2 rounded"
                          onClick={() => handleReAdd(row)}
                        >
                          {row.key}: {row.value}
                        </li>
                      ))}
                    </ul>
                    <button
                      onClick={() => setIsModalOpens(false)}
                      className="mt-4 bg-blue-500 text-white p-2 rounded"
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex border-3 border-black w-full overflow-scroll scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-400 scrollbar-track-gray-200" style={{ height: "81vh" }}>
            <table className="table-auto w-full" style={{ height: "92vh" }}>
              <thead className="w-full sticky top-0 z-50 bg-gradient-to-r from-[#0c8c8f] via-[#155e63] to-[#0e4749]  text-white">
                <th className="w-1/7 p-2">Callout</th>
                <th className="w-7/8 p-2">Text</th>
                <th className="w-7/8 p-2"></th>
              </thead>
              <tbody className="w-full">
                {masterData !== undefined && masterData !== null && masterData.length > 0 && masterData[imgIndex].map((a, index) => (
                  // <tr className={`w-full hover:bg-slate-50 justify-center items-center bg-white`}
                  //  onContextMenu={(e) => handleCtqFactor(e, index)}
                  // >
                  <tr
                    key={index}
                    className={`w-full hover:bg-slate-50 justify-center items-center bg-white ${selectedRow === index ? "bg-red-100" : ""
                      }`}
                    onContextMenu={(e) => handleRowClick(e, index)}
                  >

                    <td className="w-1/8 border border-y text-center" onClick={() => handleZoom(a.ID)}>
                      {a.ID}
                    </td>
                    <td className="w-7/8 text-center"><textarea
                      // ref={textAreaRef}
                      value={a?.text}
                      onChange={(e) => handleTableData(e, index)}
                      className={`w-80 text-sm font-normal font-sans leading-normal p-2 rounded-xl rounded-br-none shadow-lg shadow-slate-100 dark:shadow-slate-900 focus:shadow-outline-purple dark:focus:shadow-outline-purple focus:shadow-lg border border-solid border-slate-300 hover:border-purple-500 dark:hover:border-purple-500 focus:border-purple-500 dark:focus:border-purple-500 dark:border-slate-600 ${a?.["ctq"] ? 'bg-red-200' : 'bg-white'} dark:bg-slate-900 text-slate-900 dark:text-slate-300 focus-visible:outline-0 box-border`}
                      placeholder="Empty"
                      onMouseEnter={() => setSelKey(index)}
                      onKeyDown={(e) => handleKeyDown1(e, index)}
                    // onMouseLeave={() => handleCurPos()}
                    />
                    </td>
                    <td> <Checkbox
                      {...label}
                      defaultChecked={false}
                      sx={{
                        color: red[800],
                        '&.Mui-checked': {
                          color: red[600],
                        },
                      }}
                      // checked={returnCtqBool(index)}
                      checked={a.ctq}
                      onChange={(e) => handleCtqFactor(e, index)}
                    /></td>
                  </tr>
                ))
                }
              </tbody>
            </table>
            {contextMenu && (
              <div
                className="absolute bg-white border shadow-lg p-2 rounded-md z-50"
                style={{ top: `${contextMenu.mouseY}px`, left: `${contextMenu.mouseX}px` }}
                onMouseLeave={handleCloseMenu}
              >
                <button className="px-4 py-2 text-red-600 hover:bg-gray-200 w-full text-left" onClick={handleDeleteRow}>
                  Delete
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Dialog open={open} onClose={() => setOpen(false)} className='border-sky-500'>
        <DialogTitle fontSize={25} className='w-full text-center shadow-md flex justify-center items-center'>Select symbol</DialogTitle>
        <DialogContent className='flex flex-col justify-center items-center '>
          <Grid container spacing={1}>
            {icons.map((icon, index) => (
              <Grid key={index} item>
                <button onClick={() => handleIconClick(icon)} title={`${labels[index]} - ${icon}`} className='text-3xl  mt-2 flex items-center  justify-center   border border-black   gap-x-4 p-2 rounded-2xl bg-gradient-to-b from-white to-[#00838F] ' >{icon}</button>
              </Grid>
            ))}
          </Grid>
          <br />

          <textarea
            ref={textAreaRef}
            value={masterData[imgIndex]?.[selKey]?.["text"]}
            onChange={(e) => handleTableData(e, selKey)}
            className="w-3/4 text-sm font-normal font-sans leading-normal p-3 rounded-xl rounded-br-none shadow-lg shadow-slate-100 dark:shadow-slate-900 focus:shadow-outline-purple dark:focus:shadow-outline-purple focus:shadow-lg border border-solid border-slate-300 hover:border-purple-500 dark:hover:border-purple-500 focus:border-purple-500 dark:focus:border-purple-500 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-300 focus-visible:outline-0 box-border text center"
            placeholder="Empty"
          />
        </DialogContent>
      </Dialog>
      <Modal
        open={isModalOpen}
        handleClose={handleCloseModal}
        handleConfirm={() => submitJsonData()}
      />
      {isRedirecting && <Countdown onCountdownComplete={handleCountdownComplete} />}
      <ToastContainer />
    </div >
  );
}
export default Core;